import { useState } from 'react'
import config from '~config'
import * as R from 'ramda'

import { ignitionFetch } from '~/utils/ignitionFetch'
import defaultAUSchema from './defaultAUSchema'
import defaultUKSchema from './defaultUKSchema'

const currentSchema = () => {
  switch (config.SCHEMA) {
    case 'defaultAUSchema.js':
      return { name: 'defaultAUSchema.js', data: defaultAUSchema }
    case 'defaultUKSchema.js':
      return { name: 'defaultUKSchema.js', data: defaultUKSchema }
  }
}

const errorMessage = 'An error occurred while loading your custom form. Please try again.'

const useSchema = () => {
  const [schema, setSchema] = useState({ loading: false, data: null, error: null })

  const setErrors = errors => {
    setSchema({
      loading: false,
      data: null,
      error: errors ? errors : errorMessage
    })
  }

  const generateUrl = (serviceId, childId, guid, isReEnrolment, schemaId) => {
    if (isReEnrolment && serviceId && guid) return `api/v1/re-enrolment/service/${serviceId}?guid=${guid}`

    if (childId) return `api/v1/enrolment-form/waitlist/service/${serviceId}/child/${childId}`

    if (schemaId) return `api/v1/form_schemas/service/${serviceId}/schema/${schemaId}`

    return `api/v1/form_schemas/service/${serviceId}`
  }

  const getSchema = (serviceId, childId, guid, isReEnrolment, enrolmentToken, schemaId) => {
    setSchema({ loading: true, data: null, error: null })
    if (serviceId || childId || guid) {
      const url = generateUrl(serviceId, childId, guid, isReEnrolment, schemaId)

      ignitionFetch(url, enrolmentToken ? enrolmentToken : null, {})
        .then(res => {
          const schema =
            res.data.schema && !R.isEmpty(res.data.schema) ? res.data.schema : currentSchema().data
          const formData = res.data.formData ? res.data.formData : {}
          const data = { schema: schema, formData: formData }

          setSchema({ loading: false, data: data, error: null })
        })
        .catch(res => setErrors(res.errors))
    } else if (enrolmentToken) {
      ignitionFetch('api/v1/form-data', enrolmentToken, {})
        .then(res => {
          const schema =
            res.latest_schema && !R.isEmpty(res.latest_schema) ? res.latest_schema : currentSchema().data
          const formData = res.data ? res.data : {}
          const childId = res.child_id ? res.child_id : null
          const serviceId = res.service_id ? res.service_id : null
          const data = { schema: schema, formData: formData, childId: childId, serviceId: serviceId }

          setSchema({ loading: false, data: data, error: null })
        })
        .catch(res => setErrors(res.errors))
    } else {
      setErrors()
    }
  }

  return [schema, getSchema]
}

export default useSchema
